<template>
    <div class="reserve-step" data-cy="reserve_step_review">
        <section class="reserve-step__hero">
            <div>
                <span class="reserve-step__eyebrow">Etapa 3</span>
                <h4 class="reserve-step__title">Revise e configure a reserva</h4>
                <p class="reserve-step__description">
                    Confira os dados selecionados e complete as informacoes operacionais antes de validar a reserva.
                </p>
            </div>
            <div class="reserve-step__status-card">
                <span>Resumo pronto</span>
                <strong>3 clientes · 1 lote</strong>
            </div>
        </section>

        <div class="reserve-step__layout">
            <section class="reserve-step__summary-panel">
                <div class="reserve-step__section-title">
                    <span>Dados selecionados</span>
                    <small>Revise antes de continuar</small>
                </div>

                <div class="reserve-step__summary-grid">
                    <article class="reserve-step__summary-card reserve-step__summary-card--lot">
                        <div class="reserve-step__summary-icon">
                            <i class="icon-map2"></i>
                        </div>
                        <div>
                            <span>Lote</span>
                            <h5>Quadra 001 · Lote 00012</h5>
                            <p>250m² · R$ 184.000,00 · Disponivel</p>
                        </div>
                    </article>

                    <article class="reserve-step__summary-card reserve-step__summary-card--clients">
                        <div class="reserve-step__summary-heading">
                            <div class="reserve-step__summary-icon">
                                <i class="icon-people"></i>
                            </div>
                            <div>
                                <span>Clientes</span>
                                <h5>3 adicionados</h5>
                            </div>
                        </div>
                        <div class="reserve-step__summary-content">
                            <div class="reserve-step__client-list">
                                <div>
                                    <strong>Ana Maria Souza</strong>
                                    <small>CPF 123.456.789-10 · (62) 99999-0000</small>
                                </div>
                                <div>
                                    <strong>Carlos Henrique Lima</strong>
                                    <small>CPF 987.654.321-00 · (11) 98888-1122</small>
                                </div>
                                <div>
                                    <strong>Rafaela Fernandes</strong>
                                    <small>CPF 456.789.123-44 · telefone nao informado</small>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
            </section>

            <section class="reserve-step__form-panel">
                <div class="reserve-step__section-title">
                    <span>Configuracao da reserva</span>
                    <small>Campos mockados para prototipo</small>
                </div>

                <div class="reserve-step__form-grid">
                    <div class="reserve-step__field reserve-step__field--wide">
                        <label>Corretor responsavel</label>
                        <div class="reserve-step__select-like">
                            <div>
                                <strong>Mariana Alves</strong>
                                <small>Corretor logado · preenchido automaticamente</small>
                            </div>
                            <i class="icon-lock"></i>
                        </div>
                    </div>

                    <div class="reserve-step__field reserve-step__field--wide reserve-step__field--admin">
                        <label>Corretor responsavel para administrador</label>
                        <div class="reserve-step__select-like reserve-step__select-like--editable">
                            <div>
                                <strong>Selecione um corretor</strong>
                                <small>Exibido quando o usuario for admin</small>
                            </div>
                            <i class="icon-chevron-down"></i>
                        </div>
                    </div>

                    <div class="reserve-step__field">
                        <label>Tipo da reserva</label>
                        <div class="reserve-step__select-like reserve-step__select-like--editable">
                            <div>
                                <strong>Reserva comercial</strong>
                                <small>Padrao do empreendimento</small>
                            </div>
                            <i class="icon-chevron-down"></i>
                        </div>
                    </div>

                    <div class="reserve-step__field">
                        <label>Duracao</label>
                        <div class="reserve-step__duration-control">
                            <button type="button">-</button>
                            <strong>48h</strong>
                            <button type="button">+</button>
                        </div>
                    </div>

                    <div class="reserve-step__field reserve-step__field--wide">
                        <label>Observacao</label>
                        <textarea placeholder="Adicione uma observacao importante para esta reserva">Cliente solicitou prioridade para envio da proposta ainda hoje.</textarea>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReserveStepReview',
};
</script>

<style scoped>
.reserve-step {
    display: grid;
    gap: .8rem;
}

.reserve-step__hero {
    align-items: center;
    background:
        radial-gradient(circle at 12% 18%, rgba(14, 94, 78, .15), transparent 30%),
        linear-gradient(135deg, #ffffff 0%, #f4f8f7 55%, #edf5f2 100%);
    border: 1px solid #dce8e5;
    border-radius: 20px;
    box-shadow: 0 14px 34px rgba(39, 52, 63, .07);
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(0, 1fr) 185px;
    padding: 1.15rem 1.25rem;
}

.reserve-step__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: .66rem;
    font-weight: 900;
    letter-spacing: .1rem;
    margin-bottom: .38rem;
    text-transform: uppercase;
}

.reserve-step__title {
    color: #27343f;
    font-size: 1.22rem;
    font-weight: 900;
    letter-spacing: -.02rem;
    line-height: 1.15;
    margin-bottom: .32rem;
}

.reserve-step__description {
    color: #68747f;
    font-size: .84rem;
    line-height: 1.42;
    margin: 0;
    max-width: 680px;
}

.reserve-step__status-card {
    background: rgba(255, 255, 255, .76);
    border: 1px solid rgba(14, 94, 78, .14);
    border-radius: 16px;
    padding: .75rem;
}

.reserve-step__status-card span {
    color: #0e5e4e;
    display: block;
    font-size: .64rem;
    font-weight: 900;
    letter-spacing: .06rem;
    margin-bottom: .3rem;
    text-transform: uppercase;
}

.reserve-step__status-card strong {
    color: #27343f;
    display: block;
    font-size: .88rem;
    font-weight: 900;
}

.reserve-step__layout {
    align-items: start;
    display: grid;
    gap: .8rem;
    grid-template-columns: minmax(0, .95fr) minmax(360px, 1.05fr);
}

.reserve-step__summary-panel,
.reserve-step__form-panel {
    background: #fff;
    border: 1px solid #e2e9ee;
    border-radius: 20px;
    box-shadow: 0 14px 30px rgba(39, 52, 63, .05);
    padding: .9rem;
}

.reserve-step__section-title {
    margin-bottom: .75rem;
}

.reserve-step__section-title span {
    color: #27343f;
    display: block;
    font-size: .9rem;
    font-weight: 900;
}

.reserve-step__section-title small {
    color: #7a8792;
    display: block;
    font-size: .7rem;
    font-weight: 700;
    margin-top: .2rem;
}

.reserve-step__summary-grid {
    display: grid;
    gap: .6rem;
}

.reserve-step__summary-card {
    align-items: flex-start;
    background: #f8fbfa;
    border: 1px solid #e4ecea;
    border-radius: 15px;
    display: grid;
    gap: .65rem;
    grid-template-columns: 42px minmax(0, 1fr);
    padding: .68rem;
}

.reserve-step__summary-card--clients {
    background: linear-gradient(135deg, #f8fbfa, #eef7f4);
}

.reserve-step__summary-card--lot {
    background: linear-gradient(135deg, #ffffff, #f5f8fb);
}

.reserve-step__summary-card--clients {
    display: block;
}

.reserve-step__summary-heading {
    align-items: center;
    display: grid;
    gap: .65rem;
    grid-template-columns: 42px minmax(0, 1fr);
}

.reserve-step__summary-content {
    margin-top: .65rem;
}

.reserve-step__summary-icon {
    align-items: center;
    background: #0e5e4e;
    border-radius: 14px;
    color: #fff;
    display: flex;
    height: 42px;
    justify-content: center;
    width: 42px;
}

.reserve-step__summary-card span {
    color: #0e5e4e;
    display: block;
    font-size: .64rem;
    font-weight: 900;
    letter-spacing: .05rem;
    margin-bottom: .2rem;
    text-transform: uppercase;
}

.reserve-step__summary-card h5 {
    color: #27343f;
    font-size: .86rem;
    font-weight: 900;
    margin: 0;
}

.reserve-step__summary-card p {
    color: #72808b;
    font-size: .74rem;
    line-height: 1.35;
    margin: .25rem 0 0;
}

.reserve-step__client-list {
    display: grid;
    gap: .42rem;
    margin-top: .55rem;
}

.reserve-step__client-list div {
    background: rgba(255, 255, 255, .68);
    border: 1px solid #edf2f4;
    border-radius: 12px;
    padding: .48rem .58rem;
}

.reserve-step__client-list strong {
    color: #27343f;
    display: block;
    font-size: .76rem;
    font-weight: 900;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.reserve-step__client-list small {
    color: #7a8792;
    display: block;
    font-size: .66rem;
    font-weight: 700;
    margin-top: .18rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.reserve-step__form-grid {
    display: grid;
    gap: .6rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.reserve-step__field--wide {
    grid-column: 1 / -1;
}

.reserve-step__field label {
    color: #66737e;
    display: block;
    font-size: .68rem;
    font-weight: 900;
    margin-bottom: .3rem;
}

.reserve-step__select-like,
.reserve-step__duration-control,
.reserve-step__field textarea {
    background: #f8fbfa;
    border: 1px solid #dfe8e6;
    border-radius: 14px;
}

.reserve-step__select-like {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 48px;
    padding: .55rem .68rem;
}

.reserve-step__select-like--editable {
    background: #fff;
    cursor: pointer;
}

.reserve-step__select-like strong {
    color: #27343f;
    display: block;
    font-size: .8rem;
    font-weight: 900;
}

.reserve-step__select-like small {
    color: #7a8792;
    display: block;
    font-size: .66rem;
    margin-top: .15rem;
}

.reserve-step__select-like i {
    color: #0e5e4e;
}

.reserve-step__field--admin .reserve-step__select-like {
    border-style: dashed;
}

.reserve-step__duration-control {
    align-items: center;
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr) 36px;
    min-height: 48px;
    overflow: hidden;
}

.reserve-step__duration-control button {
    background: transparent;
    border: 0;
    color: #0e5e4e;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 900;
    height: 100%;
}

.reserve-step__duration-control strong {
    color: #27343f;
    font-size: .92rem;
    font-weight: 900;
    text-align: center;
}

.reserve-step__field textarea {
    color: #27343f;
    min-height: 92px;
    outline: none;
    padding: .68rem;
    resize: vertical;
    width: 100%;
}

.reserve-step__field textarea:focus,
.reserve-step__select-like--editable:hover {
    border-color: #0e5e4e;
    box-shadow: 0 0 0 4px rgba(14, 94, 78, .1);
}

@media (max-width: 900px) {
    .reserve-step__hero,
    .reserve-step__layout {
        grid-template-columns: 1fr;
    }

    .reserve-step__hero {
        padding: 1rem;
    }
}

@media (max-width: 576px) {
    .reserve-step__form-grid {
        grid-template-columns: 1fr;
    }
}
</style>
